var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApplications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,46.75h4v-1.5H14A3.25377,3.25377,0,0,1,10.75,42V14A3.25377,3.25377,0,0,1,14,10.75H42A3.25377,3.25377,0,0,1,45.25,14v4h1.5V14A4.7554,4.7554,0,0,0,42,9.25H14A4.7554,4.7554,0,0,0,9.25,14V42A4.7554,4.7554,0,0,0,14,46.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22.75H54A3.25377,3.25377,0,0,1,57.25,26v4h1.5V26A4.7554,4.7554,0,0,0,54,21.25H26A4.7554,4.7554,0,0,0,21.25,26V54A4.7554,4.7554,0,0,0,26,58.75h4v-1.5H26A3.25377,3.25377,0,0,1,22.75,54V26A3.25377,3.25377,0,0,1,26,22.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38,70.75H66A4.7554,4.7554,0,0,0,70.75,66V38A4.7554,4.7554,0,0,0,66,33.25H38A4.7554,4.7554,0,0,0,33.25,38V66A4.7554,4.7554,0,0,0,38,70.75ZM34.75,38A3.25377,3.25377,0,0,1,38,34.75H66A3.25377,3.25377,0,0,1,69.25,38V66A3.25377,3.25377,0,0,1,66,69.25H38A3.25377,3.25377,0,0,1,34.75,66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApplications);
export default __webpack_public_path__ + "static/media/icon_applications.266d0276730ec110a781771d7f3bb27c.svg";
export { ForwardRef as ReactComponent };